import React from 'react';
import uuid from 'uuid';
import { database } from '../../utils/configureFirebase';
import { ContentWrapper, LoaderWrapper, BadgeWrapper, TextWrapper } from './style';
import { Card, CardText, CardTitle } from 'material-ui/Card';
import { Dialog, FlatButton, RaisedButton, CircularProgress, Badge, CardHeader, IconButton, TextField } from 'material-ui';
import CopyToClipBoard from 'material-ui/svg-icons/content/content-copy';
import DownloadIcon from 'material-ui/svg-icons/file/cloud-download';
import { toast } from 'react-toastify';
import csvConverter from '../../utils/CampaignCSV';

class EventCampaign extends React.Component {
    constructor() {
        super();
        this.state = {
            companyNameErrorMessage: undefined,
            companyName: undefined,
            campaignRegistrationLinkModal: false,
            isLoading: true,
            campaignName: undefined
        }
    }
    componentDidMount() {
        this.campaignRegistrationRef = database.ref('campaignRegistration');
        this.campaignRegistrationRef.on('value', this.setCampaignRegistrationData);
    }

    componentWillUnmount() {
        this.campaignRegistrationRef.off('value', this.setCampaignRegistrationData);
    }
    setCampaignRegistrationData = (snapshot) => {
        if (snapshot) {
          const campaignRegistrationData = snapshot.val();
          this.setState(() => ({
            campaignRegistrationData,
            isLoading: false,
          }));
        }
    }
    openCampaignRegistrationLinkModal = () => {
        this.setState({
            campaignRegistrationLinkModal: true
        })
    }
    closeCampaignRegistrationLinkModal = () => {
        this.setState({
            campaignRegistrationLinkModal: false
        })
    }
    createCampaignRegistrationLink = () => {
        const { campaignName } = this.state;
        if(!( campaignName && campaignName.trim() )){
            toast.error("Enter a valid campaign name",{
                position: toast.POSITION.BOTTOM_RIGHT
            });
            return;
        }
        const now = (new Date()).getTime();
        const uniqueCampaignId = uuid.v4() + now;

        const databaseRef = database.ref()
          .child(`campaignRegistration/${uniqueCampaignId}`);
    
        databaseRef
          .set({
            campaignName,
            timestamp: now,
          })
          .then(() => {
            this.closeCampaignRegistrationLinkModal();
            toast.success("Campaign Successfully Created", {
                position: toast.POSITION.BOTTOM_RIGHT
            })
          }).catch((err) => {
            console.error(err);
            toast.error("Campaign Creation Failed", {
                position: toast.POSITION.BOTTOM_RIGHT
            })
          });
    }
    getCampaignRegistrationLinkModalCode = () => {
        const { campaignRegistrationLinkModal, campaignName } = this.state;

        return (
            <Dialog
                title="Create Campaign Registration Link"
                modal
                actions={[
                    <FlatButton
                        label="Cancel"
                        primary
                        onTouchTap={this.closeCampaignRegistrationLinkModal}
                    />,
                    <RaisedButton
                        label="Create"
                        primary
                        onTouchTap={this.createCampaignRegistrationLink}
                    />,
                ]}
                open={campaignRegistrationLinkModal}
                onRequestClose={this.closeCampaignRegistrationLinkModal}
            >
                <TextField
                  hintText="Enter Campaign Name"
                  value={campaignName}
                  style={{ marginLeft: 16 }}
                  onChange={(_, value) => {
                    this.setState(() => ({
                        campaignName: value,
                    }));
                  }}
                />
                <CardText>
                    Please confirm the data that you have filled. Are you sure?
                </CardText>
            </Dialog>
        );
    }
    getCampaignCard = (eachCampaignRegistrationData, campaignId) => {
        const companyName = eachCampaignRegistrationData.campaignName 
                                ? eachCampaignRegistrationData.campaignName.toUpperCase().trim() 
                                : 'N/A';
        const campaignRegistrationCount = eachCampaignRegistrationData.registeredCandidateList
                                            ? Object.keys(eachCampaignRegistrationData.registeredCandidateList).length
                                            : 0;
        return (
          <Card key={campaignId} style={{ marginTop: '10px' }}>
            <CardTitle
              title={companyName}
              actAsExpander
              showExpandableButton
              // style={{ width: "50%" }}
            >
              <BadgeWrapper>
                <Badge
                  badgeContent={campaignRegistrationCount}
                  primary
                  badgeStyle={{ top: 0, right: 0 }}
                  //   style={{ paddingTop: "10px" }}
                />
              </BadgeWrapper>
            </CardTitle>
            <CardText expandable>
              <CardHeader title="Registration Link" />
              <TextWrapper>
                <CardText>
                  <a
                    href={`https://earlybird.myanatomy.in/campaign/candidate/${campaignId}`}
                  >
                    {`https://earlybird.myanatomy.in/campaign/candidate/${campaignId}`}
                  </a>
                </CardText>
                <IconButton
                  onClick={() =>
                    this.copyToClipboard(
                      `https://earlybird.myanatomy.in/campaign/candidate/${campaignId}`
                    )
                  }
                >
                  <CopyToClipBoard />
                </IconButton>
              </TextWrapper>
              <TextWrapper>
                <CardHeader title="Download" />
                <IconButton
                  onClick={() => {
                    this.downloadCampaignRegistration(campaignId)
                  }}
                >
                  <DownloadIcon />
                </IconButton>
              </TextWrapper>
            </CardText>
          </Card>
        );
    }
    copyToClipboard = str => {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        toast.success('Copied to Clipboard', {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }
    downloadCampaignRegistration = (campaignId) => {
        const { campaignRegistrationData } = this.state;
        const particularCampaignDetails = campaignRegistrationData[campaignId];
        if(!( 
                particularCampaignDetails && 
                particularCampaignDetails.registeredCandidateList && 
                Object.keys(particularCampaignDetails.registeredCandidateList).length 
            )) {
                toast.error('No Registration...', {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                return;
            }
        else {
            toast.success('Downloading...', {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }

        const registeredCandidateListForParticularCampaign = particularCampaignDetails.registeredCandidateList;
        const dataSetWithOldDataFormat = Object.keys(registeredCandidateListForParticularCampaign)
                                            .filter(registeredCandidateId => registeredCandidateListForParticularCampaign[registeredCandidateId].degree)
                                            .map(registeredCandidateId => registeredCandidateListForParticularCampaign[registeredCandidateId]);
        const dataSetWithNewDataFormat = Object.keys(registeredCandidateListForParticularCampaign)
                                            .filter(registeredCandidateId => !registeredCandidateListForParticularCampaign[registeredCandidateId].degree)
                                            .map(registeredCandidateId => registeredCandidateListForParticularCampaign[registeredCandidateId]);
        
        // console.log('====1==>', dataSetWithOldDataFormat);
        // console.log('====2==>', dataSetWithNewDataFormat);

        let finalDataFormat = dataSetWithOldDataFormat.map(candidateRecord => {
            const { degree, specialisation, semester, aggregate, ...restCandidateRecord } = candidateRecord;
            let degreeDataFlag, degreeDataSet;
            if( degree.toLowerCase().includes('bachelors') || degree.toLowerCase().includes('under') ){
                degreeDataFlag = 'bachelors';
            } else {
                degreeDataFlag = 'masters';
            }

            switch(degreeDataFlag){
                case 'bachelors': {
                    let bachelorDegree = degree;
                    let bachelorSemester = semester;
                    let bachelorAggregate = aggregate;
                    let bachelorSpecialisation = specialisation;

                    degreeDataSet = {
                        bachelorDegree,
                        bachelorSemester,
                        bachelorAggregate,
                        bachelorSpecialisation
                    }
                    break;
                }
                case 'masters': {
                    let masterDegree = degree.replace("Mastrers", "Masters");
                    let masterSemester = semester;
                    let masterAggregate = aggregate;
                    let masterSpecialisation = specialisation;
                    let bachelorDegree = 'N/A';
                    let bachelorSemester = 'N/A';
                    let bachelorAggregate = 'N/A';
                    let bachelorSpecialisation = 'N/A';

                    degreeDataSet = {
                        bachelorDegree,
                        bachelorSemester,
                        bachelorAggregate,
                        bachelorSpecialisation,
                        masterDegree,
                        masterSemester,
                        masterAggregate,
                        masterSpecialisation
                    }
                    break;
                }
                default: {
                    degreeDataSet = {};
                }
            }
            const newCandidateRecord = Object.assign(restCandidateRecord, degreeDataSet);
            return newCandidateRecord;
        });

        finalDataFormat.push(...dataSetWithNewDataFormat);

        finalDataFormat = finalDataFormat.map(dataBlock => ({
            ...dataBlock,
            timestamp: `${new Date(dataBlock.timestamp).toLocaleDateString()} ${new Date(dataBlock.timestamp).toLocaleTimeString()}`
        }))

        // console.log('======>', finalDataFormat);
        csvConverter(finalDataFormat, `${particularCampaignDetails.campaignName} Campaign Registration`);
        
    }
    render() {
        const { isLoading, campaignRegistrationData } = this.state;
        if (!campaignRegistrationData || isLoading) {
            return (
                <ContentWrapper>
                    <LoaderWrapper>
                        <CircularProgress />
                    </LoaderWrapper>
                </ContentWrapper>
            );
        }
        return (
            <div>
                <ContentWrapper>
                    <RaisedButton
                        label="Create Campaign Registration Link"
                        primary
                        onTouchTap={this.openCampaignRegistrationLinkModal}
                    />
                    <br /><br />
                    {
                        Object
                            .keys(campaignRegistrationData)
                            .map(campaignId => this.getCampaignCard(campaignRegistrationData[campaignId], campaignId))
                    }
                    {this.getCampaignRegistrationLinkModalCode()}
                </ContentWrapper>
            </div>
        )
    }
}

export default EventCampaign;


// WEBPACK FOOTER //
// ./src/views/EventCampaign/EventCampaign.js